import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import DashUserLoadStatusViewForm from './DashUserLoadStatusViewForm'
import DashUserLoadStatusEditForm from './DashUserLoadStatusEditForm'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import DashUserLoadStatusKeys from 'src/constants/locale/key/ForwardHub'

const { CngTabs } = components


function EditPage({ showNotification }) {
	const { id } = useParams()
  const { translate } = useTranslation([Namespace.DASH_LOAD_STATUS])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let dashLoadStatus = translate(
      Namespace.DASH_LOAD_STATUS,
      DashUserLoadStatusKeys.TITLE
    )

    return {
      dashLoadStatus
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <DashUserLoadStatusViewForm
							showNotification={showNotification}
							id={id}
							onFetchPreSuccess={(datum) => {
							// this is intentional
              }}
						/>
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.dashLoadStatus,
              tabContent: (
                <DashUserLoadStatusEditForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default EditPage